<template>
	<div class="md-layout">
		<entity-card v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity }" :entity.sync="entity"></entity-card>
	</div>
</template>

<script>
	import Manual from "@/models/manual.model.vue"
	import EntityCard from "@/components/Espresso/EntityCard.vue"

	export default {
		components: {
			EntityCard,
		},
		data() {
			return {
				entity: {
					id: this.$route.params.id,
				},
				schema: Manual.getSchema(),
			}
		},
		methods: {
			async createEntity(entity) {
				this.entity = await Manual.create(entity);
				this.$router.replace(`/manual/${this.entity.id}`);
				return this.entity;
			},
			async readEntity(entityId) {
				return Manual.read(entityId);
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
				return Manual.update(dataToUpdate);
			},
			async deleteEntity(entityId) {
				await Manual.delete(entityId);
				this.$router.push("/manuais");
			},
		},
	};
</script>
